import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumLicenses({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M240 240C240 233.373 245.373 228 252 228H420C426.627 228 432 233.373 432 240V252C432 258.627 426.627 264 420 264H252C245.373 264 240 258.627 240 252V240Z"
        fill="white"
      />
      <path
        d="M240 324C240 317.373 245.373 312 252 312H420C426.627 312 432 317.373 432 324V336C432 342.627 426.627 348 420 348H252C245.373 348 240 342.627 240 336V324Z"
        fill="white"
      />
      <path
        d="M240 408C240 401.373 245.373 396 252 396H372C378.627 396 384 401.373 384 408V420C384 426.627 378.627 432 372 432H252C245.373 432 240 426.627 240 420V408Z"
        fill="white"
      />
      <path
        d="M168 156C168 142.745 178.745 132 192 132V156H168Z"
        fill="white"
      />
      <path
        d="M480 132C493.255 132 504 142.745 504 156H480V132Z"
        fill="white"
      />
      <path
        d="M168 504H192V528C178.745 528 168 517.255 168 504Z"
        fill="white"
      />
      <path d="M192 132H480V156H192V132Z" fill="white" />
      <path
        d="M192 504H396C402.627 504 408 509.373 408 516C408 522.627 402.627 528 396 528H192V504Z"
        fill="white"
      />
      <path d="M168 156H192V504H168V156Z" fill="white" />
      <path
        d="M480 156H504V324C504 330.627 498.627 336 492 336C485.373 336 480 330.627 480 324V156Z"
        fill="white"
      />
      <path
        d="M457.657 586.343C452.617 591.383 444 587.814 444 580.686V500L491.5 527.999L540 500L492 552L457.657 586.343Z"
        fill="#57D7D9"
      />
      <path
        d="M526.343 586.343C531.383 591.383 540 587.814 540 580.686V500L492 552L526.343 586.343Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M492 360C538.392 360 576 397.608 576 444C576 490.392 538.392 528 492 528C445.608 528 408 490.392 408 444C408 397.608 445.608 360 492 360ZM492 384C458.863 384 432 410.863 432 444C432 477.137 458.863 504 492 504C525.137 504 552 477.137 552 444C552 410.863 525.137 384 492 384Z"
        fill="#57D7D9"
      />
      <path
        d="M456 444C456 424.118 472.118 408 492 408C511.882 408 528 424.118 528 444C528 463.882 511.882 480 492 480C472.118 480 456 463.882 456 444Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
